export var TableName;
(function (TableName) {
    TableName["QNA_NODE"] = "qnaNode";
    TableName["QNA_NODE_USER"] = "qnaNodeUser";
    TableName["SYNC_BOX_CONFIG"] = "syncBoxConfig";
    TableName["SYNC_BOX_STATE"] = "syncBoxState";
})(TableName || (TableName = {}));
